module.exports = __webpack_public_path__ + "img/1.92d590be.jpg";